import { render, staticRenderFns } from "./Hotelidinfo.vue?vue&type=template&id=1c83d619"
import script from "./Hotelidinfo.vue?vue&type=script&setup=true&lang=js"
export * from "./Hotelidinfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Hotelidinfo.vue?vue&type=style&index=0&id=1c83d619&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports